import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8026 4.09468L10.6976 1.98855C10.3057 1.59472 9.83964 1.28248 9.32631 1.0699C8.81299 0.857306 8.26262 0.748584 7.70701 0.750014H4.9792C4.17832 0.750973 3.41052 1.06955 2.84421 1.63585C2.27791 2.20216 1.95933 2.96996 1.95837 3.77084V12.2292C1.95933 13.03 2.27791 13.7979 2.84421 14.3642C3.41052 14.9305 4.17832 15.249 4.9792 15.25H11.0209C11.8217 15.249 12.5895 14.9305 13.1559 14.3642C13.7222 13.7979 14.0407 13.03 14.0417 12.2292V7.08469C14.0432 6.52912 13.9345 5.97876 13.7217 5.46551C13.509 4.95227 13.1966 4.48632 12.8026 4.09468ZM11.9483 4.94897C12.1327 5.13876 12.2914 5.35206 12.4201 5.58334H9.81253C9.6523 5.58334 9.49863 5.51969 9.38532 5.40639C9.27202 5.29308 9.20837 5.13941 9.20837 4.97918V2.3716C9.43972 2.50024 9.6532 2.65867 9.84335 2.84285L11.9483 4.94897ZM12.8334 12.2292C12.8334 12.7099 12.6424 13.1709 12.3025 13.5108C11.9626 13.8507 11.5016 14.0417 11.0209 14.0417H4.9792C4.4985 14.0417 4.03748 13.8507 3.69757 13.5108C3.35767 13.1709 3.16671 12.7099 3.16671 12.2292V3.77084C3.16671 3.29014 3.35767 2.82912 3.69757 2.48921C4.03748 2.14931 4.4985 1.95835 4.9792 1.95835H7.70701C7.8061 1.95835 7.90216 1.97768 8.00003 1.98674V4.97918C8.00003 5.45988 8.19099 5.9209 8.5309 6.26081C8.87081 6.60072 9.33183 6.79167 9.81253 6.79167H12.805C12.814 6.88955 12.8334 6.98501 12.8334 7.08469V12.2292Z"
      fill="#151718"
    />
  </svg>
);

const DocumentIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default DocumentIcon;
